// extracted by mini-css-extract-plugin
export default {"cooper":"StyledEasySpan-module__cooper___1xTBR"};